import {
  type LearningGrain,
  LearningGrainInput
} from '@/core/domain/learning/grain/LearningGrain.ts'
import type { ILearningGrainRepository } from '@/core/domain/learning/grain/ILearningGrainRepository.ts'

export class UpdateLearningGrainUseCase {
  private readonly learningGrainRepository: ILearningGrainRepository

  constructor(learningGrainRepository: ILearningGrainRepository) {
    this.learningGrainRepository = learningGrainRepository
  }

  async execute(
    courseId: number,
    moduleId: number,
    grainId: number,
    grain: LearningGrainInput
  ): Promise<LearningGrain> {
    return this.learningGrainRepository.updateLearningGrain(courseId, moduleId, grainId, grain)
  }
}
